import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { LoteMadeira } from '../../types/aquisicao';
import { lotesMadeiraService } from '../../services';

const columns: ResourceColumn<LoteMadeira>[] = [
  { header: 'Código', accessor: 'codigo' },
  { header: 'Fornecedor', accessor: 'fornecedor_nome' },
  {
    header: 'Produto',
    render: (item) =>
      item.produto_info
        ? item.produto_info.codigo + ' - ' + item.produto_info.descricao
        : item.tipo_madeira_info
        ? item.tipo_madeira_info.codigo + ' - ' + item.tipo_madeira_info.descricao
        : '—',
  },
  {
    header: 'Volume (m³)',
    accessor: 'volume_entrada',
    render: (item) => item.volume_entrada?.toFixed(2) ?? '—',
  },
  {
    header: 'Peso (ton)',
    accessor: 'peso_entrada',
    render: (item) => item.peso_entrada?.toFixed(2) ?? '—',
  },
  {
    header: 'Umidade (%)',
    accessor: 'umidade_entrada',
    render: (item) => item.umidade_entrada?.toFixed(1) ?? '—',
  },
  {
    header: 'Status',
    accessor: 'status_tratamento',
    render: (item) => {
      const statusMap: Record<string, string> = {
        PENDENTE: 'Pendente',
        EM_TRATAMENTO: 'Em Tratamento',
        CONCLUIDO: 'Concluído',
        REPROVADO: 'Reprovado',
      };
      return statusMap[item.status_tratamento] ?? item.status_tratamento;
    },
  },
  { header: 'Recebido em', accessor: 'data_recebimento' },
];

export const LotesMadeiraListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Lotes de Madeira"
      description="Gestão de lotes de madeira recebidos para produção"
      columns={columns}
      service={lotesMadeiraService}
      createPath="/admin/producao/lotes-madeira/novo"
      onEdit={(item) => item.id && navigate('/admin/producao/lotes-madeira/' + item.id)}
      onDelete={(item) => (item.id ? lotesMadeiraService.remove(item.id) : Promise.resolve())}
      searchPlaceholder="Buscar por fornecedor ou produto..."
    />
  );
};
